import React, { useState, useEffect } from 'react'
import HeadingArea from '../../general/HeadingArea';
import { AiOutlinePlus } from 'react-icons/ai';
import ResponseMsg2 from '../../general/ResponseMsg2';
import { Link } from 'react-router-dom';
import { FaFileImage, FaFilePdf } from 'react-icons/fa';
import { RiDeleteBin6Line } from 'react-icons/ri';

const UploadContent = ({ setLoading, userData }) => {
    const [classes, setClasses] = useState([]);
    const [availableSections, setAvailableSections] = useState([]);
    const [date, setDate] = useState("");
    const [selectedClassId, setSelectedClassId] = useState('');
    const [selectedClassName, setSelectedClassName] = useState('');
    const [selectedSection, setSelectedSection] = useState('');
    const [formData, setFormData] = useState({
        title: '',
        c_type: '',
        description: '',
        source: '',
    });
    const [mediaFiles, setMediaFiles] = useState(null);
    const [response2, setResponse2] = useState({ message: '', status: 'success' });
    const [response1, setResponse1] = useState('');
    const [myContent, setMyContent] = useState([]);
    const [selectedContent, setSelectedContent] = useState('');
    const [showDelete, setShowDelete] = useState(false);
const [searchTerm, setSearchTerm] = useState('');


    const fetchClasses = async () => {
        setLoading(true);
        try {
            const response = await fetch('https://api.kcian.in/get-classes');
            if (response.ok) {
                const data = await response.json();
                setClasses(data);
            } else {
                console.error('Failed to fetch class list');
            }
        } catch (error) {
            console.error('Error fetching classes:', error);
        } finally {
            setLoading(false);
        }
    };


    const fetchContent = async () => {
        setLoading(true);
        try {
            const response = await fetch('https://api.kcian.in/get-uploaded-content');
            if (response.ok) {
                let data = await response.json();
                if(userData.role == 'Teacher'){
                    data = data.filter(item => item.added_by == userData.user_id);
                }
                setMyContent(data);
            } else {
                console.error('Failed to fetch content');
            }
        } catch (error) {
            console.error('Error fetching content:', error);
        } finally {
            setLoading(false);
        }
    };


    useEffect(() => {
        fetchClasses();
        fetchContent();
    }, []);


    useEffect(() => {
        if (selectedClassId && classes.length > 0) {
            const selectedClass = classes.find(cls => cls.id === Number(selectedClassId));
            if (selectedClass && selectedClass.sections) {
                const sectionArray = selectedClass.sections
                    .split(',')
                    .map(section => section.trim())
                    .filter(section => section !== '');
                setAvailableSections(sectionArray);
            } else {
                setAvailableSections([]);
            }
        } else {
            setAvailableSections([]);
        }
    }, [selectedClassId, classes]);


    // Handle input change for controlled inputs
    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({ ...prev, [name]: value }));
    };

    // Handle file input change
    const handleFileChange = (e) => {
        setMediaFiles(e.target.files); // FileList object
    };

    // Handle form submit
    const handleSubmit = async (e) => {
        e.preventDefault();

        // Validate required fields
        if (!formData.source && (!mediaFiles || mediaFiles.length === 0)) {
            setResponse2({ message: 'Please Add Content URL or Attach File.', status: 'error' });
            setTimeout(() => {
                setResponse2('');
            }, 3000);
            return;
        }


        setLoading(true);
        setResponse2({ message: '', status: '' });

        try {
            const data = new FormData();
            data.append('title', formData.title);
            data.append('c_type', formData.c_type);
            data.append('class_name', selectedClassName);
            data.append('section', selectedSection);
            data.append('date', date);
            data.append('description', formData.description);
            data.append('source', formData.source);

            // Append all selected files
            if (mediaFiles) {
                for (let i = 0; i < mediaFiles.length; i++) {
                    data.append('media', mediaFiles[i]);
                }
            }

            const response = await fetch(`https://api.kcian.in/upload-content/${userData.user_id}`, {
                method: 'POST',
                body: data,
            });

            if (response.ok) {
                const resData = await response.json();
                setResponse1('Content uploaded successfully!');

                // Reset form
                setFormData({
                    title: '',
                    c_type: '',
                    description: '',
                    source: '',
                });
                setSelectedClassId('');
                setSelectedSection('');
                setSelectedClassName('');
                setDate('');
                setMediaFiles(null);

                // Clear file input manually if needed (see note below)
                document.getElementById('myFile').value = null;
                fetchContent();
            } else {
                const errData = await response.json();
                setResponse1(errData.message || 'Upload failed.');
            }
        } catch (error) {
            console.error('Error uploading content:', error);
        } finally {
            setLoading(false);
            setTimeout(() => {
                setResponse1('');
            }, 3000);
        }
    };


    const handleShowDelete = (uc) => {
    setSelectedContent(uc);
    setShowDelete(true);
  }


                const handleDelete = async (cId, cMedia) => {
    try {
      const response = await fetch(`https://api.kcian.in/delete-content/${cId}?media=${encodeURIComponent(cMedia)}`, {
        method: 'DELETE',
      });


      if (response.ok) {
setMyContent((prevData) => prevData.filter((product) => product.id !== cId));
        setShowDelete(false);
        setResponse2({ message: 'Content Removed successfully!', status: 'success' });
        setTimeout(() => {
          setResponse2('');
        }, 3000);
      } else {
                setResponse2({ message: 'Something Went Wrong. Please try again.', status: 'error' });
        setTimeout(() => {
          setResponse2('');
        }, 3000);   
      }
    } catch (error) {
      console.error('Error deleting content:', error);
    }
  };


const filteredContent = myContent.filter(uc => {
  const term = searchTerm.toLowerCase();

  const isUserMatch = uc.user_name.toLowerCase().includes(term);
  const isClassMatch = uc.class_name.toLowerCase().includes(term);
  const isAdminMatch = uc.role === 'SupAdmin' && 'admin'.includes(term);

  return isUserMatch || isClassMatch || isAdminMatch;
});


    return (
        <>
        <section className='py-4'>
            <div className='px-4'>
                <HeadingArea message1="Study Material" message2="Upload Content" />

                                {response2.message && <ResponseMsg2 message={response2.message} status={response2.status} />}

                <div className='row'>
                    <div className='col-xl-3 col-lg-4 col-md-5 col-12 my-2'>
                        <div className="profile-card">
                            <p className="profile-heading">Upload Content</p>
                            <form className='mt-4' onSubmit={handleSubmit}>
                                <div className='profile-input-area mb-4'>
                                    <label className='profile-badge'>Content Title*</label>
                                    <input
                                        name='title'
                                        className='profile-input'
                                        type='text'
                                        value={formData.title}
                                        onChange={handleInputChange}
                                        required
                                    />
                                </div>

                                <div className='profile-input-area mb-4'>
                                    <label className='profile-badge'>Content Type*</label>
                                    <select
                                        name='c_type'
                                        className='profile-input'
                                        value={formData.c_type}
                                        onChange={handleInputChange}
                                        required
                                    >
                                        <option value=''>Content Type</option>
                                        <option value='Assignment'>Assignment</option>
                                        <option value='Syllabus'>Syllabus</option>
                                        <option value='Other'>Other</option>
                                    </select>
                                </div>

                                <div className='profile-input-area mb-4'>
                                    <label className='profile-badge'>Class*</label>
                                    <select
                                        name='class_name'
                                        className='profile-input'
                                        value={selectedClassId}
                                        onChange={(e) => {
                                            const classId = e.target.value;
                                            setSelectedClassId(classId);
                                            const selected = classes.find(cls => cls.id === Number(classId));
                                            setSelectedClassName(selected?.class_name || '');
                                        }} required
                                    >
                                        <option value="">-- Select Class --</option>
                                        {classes.map((cls) => (
                                            <option key={cls.id} value={cls.id}>
                                                {cls.class_name}
                                            </option>
                                        ))}
                                    </select>
                                </div>

                                <div className='profile-input-area mb-4'>
                                    <label className='profile-badge'>Section*</label>
                                    <select
                                        name='section'
                                        className='profile-input'
                                        value={selectedSection}
                                        onChange={(e) => setSelectedSection(e.target.value)}
                                        required
                                    >
                                        <option value="">-- Select Section --</option>
                                        {availableSections.map((section, idx) => (
                                            <option key={idx} value={section}>
                                                {section}
                                            </option>
                                        ))}
                                    </select>
                                </div>

                                <div className="profile-input-area mb-4">
                                    <label htmlFor="date" className="profile-badge">Date*</label>
                                    <input
                                        type="date"
                                        id="date"
                                        className="profile-input"
                                        value={date}
                                        onChange={(e) => setDate(e.target.value)}
                                        required
                                    />
                                </div>

                                <div className="profile-input-area mb-4">
                                    <label htmlFor="description" className="profile-badge">Description</label>
                                    <textarea
                                        name="description"
                                        className="profile-input"
                                        value={formData.description}
                                        onChange={handleInputChange}
                                    />
                                </div>

                                <div className='profile-input-area mb-4'>
                                    <label className='profile-badge'>Source URL</label>
                                    <input
                                        name='source'
                                        className='profile-input'
                                        type='text'
                                        value={formData.source}
                                        onChange={handleInputChange}
                                    />
                                </div>

                                <div className="profile-input-area mb-4">
                                    <label htmlFor="myFile" className="profile-badge">Image/ Pdf</label>
                                    <input
                                        type="file"
                                        id="myFile"
                                        name="media"
                                        accept=".pdf, image/*"
                                        className='profile-input'
                                        multiple
                                        onChange={handleFileChange}
                                    />
                                </div>

                                {response1 && <p className='mt-0 fw-semibold'>{response1}</p>}

                                <div className='text-center'>
                                    <button type="submit" className="profile-btn me-2">
                                        <AiOutlinePlus /> Add
                                    </button>
                                </div>
                            </form>
                        </div>
                    </div>

                    {/* Right side */}
                    <div className='col-xl-9 col-lg-8 col-md-7 col-12 my-2 h-100'>
                        <div className='profile-card'>

                            <div className='d-md-flex d-sm-flex justify-content-between mb-2'>
                                <span className="profile-heading align-content-center">Content List</span>

                  <div className='profile-input-area ms-auto col-lg-3 border-0'>
<input
  type='text'
  name='search'
  className='profile-input border-bottom rounded-0'
  placeholder='Search By Class, Teacher'
  value={searchTerm}
  onChange={(e) => setSearchTerm(e.target.value)}
/>
</div>
  </div>
                            <div className='table-responsive'>
                                <table className='w-100'>

                                    <thead className='account-thead'>
                                        <th className='rounded-start-4'>S No</th>
                                        <th>Content Title</th>
                                        <th>Type</th>
                                        <th>Date</th>
                                        <th>Added By</th>
                                        <th>Class(Section)</th>
                                        <th>Source</th>
                                        <th>Media</th>
                                        <th className='rounded-end-4'>Activity</th>
                                    </thead>


                                    {filteredContent.map((uc, index) => (
                                        <tr className='account-tr'>
                                            <td>{index + 1}</td>
                                            <td>{uc.title}</td>
                                            <td>{uc.c_type}</td>
                                            <td>{uc.date}</td>
                                            <td>
                                                {uc.role === 'SupAdmin'
                                                    ? 'Admin'
                                                    : `${uc.user_name}(${uc.designation})`}
                                            </td>
                                            <td>{uc.class_name}({uc.section})</td>
                                            <td>{uc.source ? <Link to={uc.source} target='_blank'>Click Here</Link> : '--'}</td>
                                            <td>
                                                {uc.media ? (() => {
                                                    // Extract file extension
                                                    const ext = uc.media.split('.').pop().toLowerCase();

                                                    const imageExts = ['jpg', 'jpeg', 'png', 'gif', 'bmp', 'webp'];

                                                    const handleClick = () => {
                                                        window.open(`https://api.kcian.in/inUploads/${uc.media}`, '_blank');
                                                    };

                                                    if (ext === 'pdf') {
                                                        return <FaFilePdf style={{ cursor: 'pointer', color: 'red' }} size={21} onClick={handleClick} title="View Document" />;
                                                    } else if (imageExts.includes(ext)) {
                                                        return <FaFileImage style={{ cursor: 'pointer', color: 'purple' }} size={21} onClick={handleClick} title="View Image" />;
                                                    } else {
                                                        return '--';
                                                    }
                                                })() : '--'}
                                            </td> 
                                            <td><RiDeleteBin6Line className='account-icon2' title='Remove' onClick={() => handleShowDelete(uc)} /></td>                                  
                                             </tr>
                                    ))}


                                </table>
                            </div>

                        </div>
                    </div>


                </div>
            </div>
        </section>


      {showDelete && (
  <>
        <section className='ins-dialog'>
          <div className='ins-dialog-inner col-lg-10 col-12 animate__animated animate__fadeInDown mx-auto' onClick={(e) => e.stopPropagation()}>

            <p className='ins-dialog-heading text-danger'>Remove This Content!</p>

<div className='table-responsive'>
<table className='w-100'>

                                    <thead className='account-thead'>
                                        <th className='rounded-start-4'>Content Title</th>
                                        <th>Type</th>
                                        <th>Date</th>
                                        <th>Added By</th>
                                        <th>Class(Section)</th>
                                        <th>Source</th>
                                        <th className='rounded-end-4'>Media</th>
                                    </thead>

<tr className='account-tr'>
                                            <td>{selectedContent.title}</td>
                                            <td>{selectedContent.c_type}</td>
                                            <td>{selectedContent.date}</td>
                                            <td>
                                                {selectedContent.role === 'SupAdmin'
                                                    ? 'Admin'
                                                    : `${selectedContent.user_name}(${selectedContent.designation})`}
                                            </td>
                                            <td>{selectedContent.class_name}({selectedContent.section})</td>
                                            <td>{selectedContent.source ? <Link to={selectedContent.source} target='_blank'>Click Here</Link> : '--'}</td>
                                            <td>
                                                {selectedContent.media ? (() => {
                                                    // Extract file extension
                                                    const ext = selectedContent.media.split('.').pop().toLowerCase();

                                                    const imageExts = ['jpg', 'jpeg', 'png', 'gif', 'bmp', 'webp'];

                                                    const handleClick = () => {
                                                        window.open(`https://api.kcian.in/inUploads/${selectedContent.media}`, '_blank');
                                                    };

                                                    if (ext === 'pdf') {
                                                        return <FaFilePdf style={{ cursor: 'pointer', color: 'red' }} size={21} onClick={handleClick} title="View Document" />;
                                                    } else if (imageExts.includes(ext)) {
                                                        return <FaFileImage style={{ cursor: 'pointer', color: 'purple' }} size={21} onClick={handleClick} title="View Image" />;
                                                    } else {
                                                        return '--';
                                                    }
                                                })() : '--'}
                                            </td> 
</tr>


</table>
</div>

<p className='para-text mt-3'>Note: This action cannot be undone. Once deleted, the Uploaded Content will be permanently removed.</p>

            <button className='profile-btn me-2' onClick={() => handleDelete(selectedContent.id, selectedContent.media)}>Remove</button>
            <button className='profile-btn2' onClick={() => setShowDelete(false)}>Go Back</button>


    </div>
  </section>
  </>
)}

        </>
    )
}

export default UploadContent